import ParentView from "../../Views/PrarentView/ParentView";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setSelectedPuja } from "../../store/slices/pujaSlice";
import { uid } from "../../utils/HelperFunctions";
import { updateTempCartPayloadAction } from "../../store/actions/cartAction";
import { orderType, packageType } from "../../utils/Constants";

import HelmetComponent from "../../components/Shared/HelmetComponent";

import ChadavaPackageDetailsView from "../../Views/ChadavaPackage/ChadavaPackageDetailsView";
import {
  getChadhavaPackageDetailsAction,
  getPujaPackagePriceAction,
} from "../../store/actions/ChadhawaAction";

function ChadavaPackageInfoScreen(props: any) {
  const location = useLocation();
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const [chadhavaPackageDetails, setChadhavaPackageDetails] =
    useState<any>(null);
  const [popupPujaAlreadyAdded, setPopupPujaAlreadyAdded] = useState(false);
  const [itemAddLimitPopUp, setItemAddLimitPopUp] = useState(false);
  var { currentGPSAddress } = useSelector((state: any) => state.user);
  const [avialableCouponCode, setAvailableCouponCode] = useState(null);
  const [pujaPriceInfo, setPujaPriceInfo] = useState<any>(null);
  const [userReview, setUserReview] = useState<any>([]);
  const [chadhavaPackagePrice, setChadhavaPackagePrice] = useState<any>(null);
  const [chadhavaSubscriptionPrices, setChadhavaSubscriptionPrices] = useState<
    any[]
  >([]);
  const [selectedPlan, setSelectedPlan] = useState<any>(null);

  const { selectedTempleDetails, benefitsList } = useSelector(
    (state: any) => state.temple
  );
  const { chadhavaVideos} = useSelector((state:any)=>state.dashboard)
  const { cartInfo } = useSelector((state: any) => state.cart);
  const queryParams = new URLSearchParams(location.search);
  const pujaNameKey = queryParams.get("pujaNameKey");
  const priceConversionState = useSelector(
    (state: any) => state.priceConversion
  );
  const {
    rate = 1,
    currencySymbols = "₹",
    isOverseas = false,
  } = priceConversionState.priceConversionRate || {};

  const getTempleNameById = (templeList: any, orgId: string) => {
    if (!templeList || !orgId) return "";

    const temple: any = Object.values(templeList).find(
      (t: any) => t?.id === orgId
    );

    return temple?.nameKey;
  };

  const selectChadhavaPackage = (_pujaDetails: any) => {
    const namekey = _pujaDetails?.pujaDetails?.templeNameKey;
    navigate(`/chadhavaDetails/${namekey}`);
  };

  useEffect(() => {
    if (!pujaNameKey) return;

    dispatch(getChadhavaPackageDetailsAction(pujaNameKey))
      .then(async (res: any) => {
        setChadhavaPackageDetails(res);
      })
      .catch((err: any) => {
        console.error("Error:", err);
      });
  }, [dispatch, pujaNameKey]);

  useEffect(() => {
    const getPriceFRomServer = async () => {
      if (
        chadhavaPackageDetails?.id &&
        chadhavaPackageDetails?.priceBreakupV1
      ) {
        try {
          const packagePrice = await dispatch(
            getPujaPackagePriceAction(
              chadhavaPackageDetails.priceBreakupV1,
              isOverseas,
              rate,
              false
            )
          );
          setPujaPriceInfo(packagePrice);
          setChadhavaPackagePrice(packagePrice);
          if (
            Array.isArray(chadhavaPackageDetails?.subscriptions) &&
            chadhavaPackageDetails.subscriptions.length > 0
          ) {
            const subscriptionPrices = await Promise.all(
              chadhavaPackageDetails.subscriptions.map((sub: any) =>
                dispatch(
                  getPujaPackagePriceAction(
                    sub.priceBreakupV1,
                    isOverseas,
                    rate,
                    false
                  )
                )
              )
            );

            setChadhavaSubscriptionPrices(subscriptionPrices);
          }
        } catch (error) {
          console.error("Error fetching price:", error);
        }
      }
    };

    getPriceFRomServer();
  }, [rate, isOverseas, chadhavaPackageDetails?.id]);

  useEffect(() => {
    if (
      chadhavaPackageDetails?.isOnlySubscription === true &&
      chadhavaPackageDetails?.isSubscriptionEnable === true &&
      Array.isArray(chadhavaPackageDetails?.subscriptions) &&
      chadhavaPackageDetails.subscriptions.length > 0
    ) {
      const subPlan = chadhavaPackageDetails.subscriptions[0];
      const subPriceInfo = chadhavaSubscriptionPrices?.[0] ?? {};
      setSelectedPlan({ ...subPlan, ...subPriceInfo, id: subPlan.id });
      setPujaPriceInfo(subPriceInfo);
    }
  }, [
    chadhavaPackageDetails?.isOnlySubscription,
    chadhavaPackageDetails?.isSubscriptionEnable,
    chadhavaPackageDetails?.subscriptions,
    chadhavaSubscriptionPrices,
  ]);

  const preprocessingAndProceedToAddmemberScreen = async () => {
    if (cartInfo && cartInfo.length >= 6) {
      setItemAddLimitPopUp(true);
      return;
    }
    dispatch(setSelectedPuja(chadhavaPackageDetails));

    const id = uid();
    let cartDataPayload: any = {
      id: id,
      cartId: id,
      membersData: [],
      // bookedForDate: {
      //   pujaDate: "2025-11-18",
      //   pujaTime: "10:30AM",
      // },
      bookedForDate: null,
      pujaDetails: {
        pujaId: chadhavaPackageDetails?.pujaId ?? chadhavaPackageDetails?.id,
        pujaName: chadhavaPackageDetails?.pujaName,
        pujaNameKey: chadhavaPackageDetails?.pujaNameKey,
        pujaBg: chadhavaPackageDetails?.pujaBg,
        packageItems: chadhavaPackageDetails?.packageItems ?? null,
        templeList: chadhavaPackageDetails?.templeList ?? null,
        type: chadhavaPackageDetails?.type ?? packageType.puja,
        packageDescription: chadhavaPackageDetails?.packageDescription ?? null,
        packageDetailsImage:
          chadhavaPackageDetails?.packageDetailsImage ?? null,
        priceBreakupV1: chadhavaPackageDetails?.priceBreakupV1 ?? null,
        subscriptions: chadhavaPackageDetails?.subscriptions ?? [],
      },
      isSubscribed: selectedPlan?.id ? true : false,
      ...(selectedPlan?.id && { subscriptionId: selectedPlan?.id }),
      selectedPujaPackage: chadhavaPackageDetails?.multiplePujaDetails?.length
        ? chadhavaPackageDetails?.multiplePujaDetails[0]
        : {
            packageId: uid(),
            maxMemberAllowed: "1",
            isMostPopular: false,
          },
      orderType: orderType.chadhavaPackage,
      isPrasad: false,
      tempPriceInfo: {
        finalPrice: pujaPriceInfo?.finalPrice,
      },
    };
    dispatch(updateTempCartPayloadAction(cartDataPayload)).then(() => {
      navigate(`/checkoutV2/addDevotee`);
    });
  };

  const navigateToSeeVideoView = () => {
    navigate("/pujaVideo");
  };
  const handleChadhavaPlanChange = (id: string, priceInfo: any) => {
    if (id === "") {
      setSelectedPlan(null);
      setPujaPriceInfo(chadhavaPackagePrice);
      return;
    }
    if (selectedPlan?.id === id) {
      setSelectedPlan(null);
    } else {
      const selected = chadhavaPackageDetails?.subscriptions?.find(
        (p: any) => p.id === id
      );
      setSelectedPlan({ ...selected, ...priceInfo, id });
      setPujaPriceInfo(priceInfo);
    }
  };
  return (
    <ParentView>
      <HelmetComponent>
        <ChadavaPackageDetailsView
          cartInfo={cartInfo}
          chadhavaPackageDetails={chadhavaPackageDetails}
          selectedTempleDetails={selectedTempleDetails}
          preprocessingAndProceedToAddmemberScreen={
            preprocessingAndProceedToAddmemberScreen
          }
          benefitsList={benefitsList}
          popupPujaAlreadyAdded={popupPujaAlreadyAdded}
          setPopupPujaAlreadyAdded={setPopupPujaAlreadyAdded}
          navigateToSeeVideoView={navigateToSeeVideoView}
          avialableCouponCode={avialableCouponCode}
          pujaPriceInfo={pujaPriceInfo}
          overSeasRate={rate}
          currencySymbols={currencySymbols}
          isOverseas={isOverseas}
          isCountryDisabledForBooking={
            priceConversionState?.isCountryDisabled ?? false
          }
          userReview={userReview}
          itemAddLimitPopUp={itemAddLimitPopUp}
          setItemAddLimitPopUp={setItemAddLimitPopUp}
          chadhavaPackagePrice={chadhavaPackagePrice}
          chadhavaSubscriptionPrices={chadhavaSubscriptionPrices}
          selectChadhavaPackage={selectChadhavaPackage}
          selectedPlan={selectedPlan}
          handleChadhavaPlanChange={handleChadhavaPlanChange}
          isOnlySubscriptionEnable={
            chadhavaPackageDetails?.isOnlySubscription === true &&
            chadhavaPackageDetails?.isSubscriptionEnable === true
          }
          pujaPackagePreviewVideos={chadhavaVideos|| []}
        />
      </HelmetComponent>
    </ParentView>
  );
}

export default ChadavaPackageInfoScreen;
